import type { SVGProps } from 'react';
const DawnFlagGE = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-GE_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-GE_svg__a)">
      <path
        fill="#FF2B37"
        d="M12.571 17.067H9.428V9.6H-1.048V6.4H9.428v-7.467h3.143V6.4h10.476v3.2H12.571z"
      />
      <path
        fill="#FD0D1B"
        d="m16.971 3.52-1.257.213V2.667l1.257.213-.21-1.28h1.048l-.21 1.28 1.258-.213v1.066L17.6 3.52l.21 1.28h-1.048zM4.4 3.52l-1.257.213V2.667L4.4 2.88 4.19 1.6h1.048l-.21 1.28 1.257-.213v1.066L5.028 3.52l.21 1.28H4.19zM4.4 13.12l-1.257.213v-1.066l1.257.213-.21-1.28h1.048l-.21 1.28 1.257-.213v1.066l-1.257-.213.21 1.28H4.19zM16.971 13.12l-1.257.213v-1.066l1.257.213-.21-1.28h1.048l-.21 1.28 1.258-.213v1.066L17.6 13.12l.21 1.28h-1.048z"
      />
    </g>
  </svg>
);
export default DawnFlagGE;
